// extracted by mini-css-extract-plugin
export default {"wrapper":"Exit_wrapper__e-wMr"};